import React from "react";
import {Input, Button, Dropdown }from "antd";
import Panel from "rc-color-picker/lib/Panel";

export default function ColorPicker(props) {
  const { color, onChange } = props;

  const [internalColor, setInternalColor] = React.useState(color);

  const handleChange = (color) => {
    setInternalColor(color.color);

    if (onChange) {
      onChange(color);
    }
  };

  const overlay = (
    <div>
      <Panel
        color={internalColor}
        enableAlpha={false}
        onChange={handleChange}
      />
    </div>
  );

  return (
    <>
      <Input
        value={internalColor}
        readOnly
        onChange={(e) => setInternalColor(e.target.value)}
        suffix={
          <Dropdown trigger={["click"]} overlay={overlay}>
            <Button style={{ background: internalColor }}> </Button>
          </Dropdown>
        }
      />
    </>
  );
}
